import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
import Vue from 'vue'
import router from '../router'

import request from './request'

const way = './graphql/common/',
  environment = '/common'

export async function growthbookAdminRequest(name) {
  const result = await request({
    environment,
    type: 'query',
    name,
    way,
    // Успіх — request() передає вже розгорнутий масив; GraphQL-помилка — сирий результат з errors
    callback: res => {
      if (Array.isArray(res)) {
        return res
      }
      return res?.errors?.length ? { error: res.errors[0].message } : res?.data?.[name]
    },
    catch_callback: error => ({ error: error?.message || String(error) }),
  })
  return Array.isArray(result) || result?.error ? result : { error: '' }
}

export default class SettingsApi {
  async getAllDBStorage() {
    return request(
      {
        environment: '/localStorage',
        type: 'query',
        name: 'getAll',
        way: './graphql/localStorage/',
        has_catch: true}
    )
  }
  async clearAllDBStorage() {
    return await request(
      {
        environment: '/localStorage',
        type: 'mutation',
        name: 'clearAll',
        way: './graphql/localStorage/',
        has_catch: true
      }
    )
  }

  /**
   * Сохранение массива значений
   */
  async setManyDBStorage(items) {
    return request(
      {
        environment: '/localStorage',
        type: 'mutation',
        name: 'setMany',
        variables: {items},
        way: './graphql/localStorage/',
        has_catch: true}
    )
  }
  async deleteManyDBStorage(keys) {
    return request(
      {
        environment: '/localStorage',
        type: 'mutation',
        name: 'deleteMany',
        variables: {keys},
        way: './graphql/localStorage/',
        has_catch: true}
    )
  }
  //async getDBStorage(key) {
  //  return request(
  //    {
  //      environment: '/localStorage',
  //      type: 'query',
  //      name: 'get',
  //      variables: {key},
  //      way: './graphql/localStorage/',
  //      has_catch: true}
  //  )
  //}
  //async setDBStorage(key, value, expiresAt) {
  //  return request(
  //    {
  //      environment: '/localStorage',
  //      type: 'mutation',
  //      name: 'set',
  //      variables: {key, value, expiresAt},
  //      way: './graphql/localStorage/',
  //      has_catch: true}
  //  )
  //}
  //async deleteDBStorage(key) {
  //  return request(
  //    {
  //      environment: '/localStorage',
  //      type: 'mutation',
  //      name: 'delete',
  //      variables: {key},
  //      way: './graphql/localStorage/',
  //      has_catch: true}
  //  )
  //}
  async getSettings() {
    //await Vue.prototype.$auth.renewToken(true) костыль для имени пользователя в меню, но пока не трогаем
    const user = await Vue.prototype.$auth.getUser()
    let my_local = localStorage.getObject(`${(user.profile.preferred_username || '').toLowerCase()}_settings`)
    let godMode = my_local && !!my_local.GodMode
    let settings = await import('./graphql/common/settings.gql')

    return (await getApolloClient('/common'))
      .query({
        query: gql`${settings}`,
        variables: { godMode: godMode ?? false },
      })
      .catch(error => {
        router.push(  {name: 'page-error', params: { status_code: '500', descript: 'settingsApi' } })
        Vue.prototype.$log_error(error.message, 'settings')
        Vue.prototype.$log(error, error.networkError , error.networkError.statusCode, 'settings')
        throw error
      })
  }
  async getNpsUserData() {
    let nps = await import('./graphql/common/nps.gql')
    return (await getApolloClient('/common'))
      .query({
        query: gql`${nps}`,
      })
      .catch(error => {
        Vue.prototype.$log_error(error.message, 'getNpsUserData')
        throw error
      })
  }
  async formInvoice(model) {
    let formInvoice = await import('./graphql/smarttender/formInvoice.gql')
    return (await getApolloClient('/tenders'))
      .mutate({
        mutation: gql`${ formInvoice }`,
        variables: { model }
      })
      .then(res => res.data.formInvoice)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  async getContractNumberAndTariff() {
    let tariff = await import('./graphql/common/getContractNumberAndTariff.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${tariff}`,
      })
      .then(res => res.data.getContractNumberAndTariff)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  async getContractTariffs() {
    let tariff = await import('./graphql/common/getContractTariffs.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${tariff}`,
      })
      .then(res => res.data.getContractTariffs)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  async getActiveUsers() {
    let tariff = await import('./graphql/common/activeUsers.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${tariff}`,
      })
      .then(res => res.data.activeUsers)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  async getInstructions() {
    let getInstructions = await import('./graphql/common/getInstructions.gql')
    return (await getApolloClient('/tenders'))
      .query({
        query: gql`${getInstructions}`,
      })
      .then(res => res.data.instructions)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  async getNewId() {
    return await request( {
      environment,
      type: 'query',
      name: 'getNewId',
      way: way
    })
  }
  async unleashFeature(feature) {
    return await request( {
      environment,
      type: 'query',
      variables: {
        feature
      },
      name: 'unleashFeature',
      way: way
    })
  }
  async growthbookFeatures(features) {
    return await request( {
      environment,
      type: 'query',
      variables: {
        features
      },
      name: 'growthbookFeatures',
      way: way
    })
  }

  async getTimezones(lang) {
    let timezones = await import('./graphql/common/getTimezones.gql')
    return (await getApolloClient('/tenders', undefined, undefined, lang))
      .query({
        query: gql`${timezones}`,
      })
      .then(res => res.data.timezones)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  // Конфігурація з REST API GrowthBook: масив або { error: 'текст помилки' } — щоб сторінка
  // показала справжню причину (ключ не налаштовано, 401/429 від GrowthBook, немає прав).
  // request() при GraphQL-помилці повертає лише null, а мережеву з has_catch ковтає повністю,
  // тож текст дістаємо через callback (отримує сирий результат з errors) і catch_callback
  async growthbookAdminFeatures() {
    return await growthbookAdminRequest('growthbookAdminFeatures')
  }
  async growthbookAdminProjects() {
    return await growthbookAdminRequest('growthbookAdminProjects')
  }
  async growthbookAdminEnvironments() {
    return await growthbookAdminRequest('growthbookAdminEnvironments')
  }
  async userSignedInEvent() {
    return await request( {
      environment,
      type: 'mutation',
      name: 'userSignedInEvent',
      way: way
    })
  }
}
